import type { ChangeEventHandler, ReactNode } from 'react'

import clsx from 'clsx'
import type { DateTimePickerProps } from 'react-flatpickr'
import Flatpickr from 'react-flatpickr'

import './timepicker.css'

const TimepickerInput = ({
  value = '',
  onChange,
  inputRef,
  className,
  children,
  ...props
}: Omit<DateTimePickerProps, 'options' | 'render'> & {
  inputRef: (node: HTMLInputElement | null) => void
  children?: ReactNode
}): JSX.Element => {
  return (
    <div className={className}>
      <input
        {...props}
        type='text'
        value={value as string | number | readonly string[]}
        onChange={onChange as unknown as ChangeEventHandler<HTMLInputElement>}
        ref={inputRef}
        className='bg-transparent w-full outline-none text-neutral-500'
        readOnly
      />
      {children}
    </div>
  )
}

const Timepicker = ({
  className,
  children,
  label,
  options = {
    enableTime: true,
    noCalendar: true,
    dateFormat: 'H:i',
    time_24hr: true
  },
  ...props
}: DateTimePickerProps & { label?: string }): JSX.Element => {
  return (
    <div className={clsx(className)}>
      {label ? <label htmlFor='time-picker'>{label}</label> : null}
      <Flatpickr
        id='time-picker'
        data-enable-time
        options={options}
        render={(props, ref): JSX.Element => (
          <TimepickerInput
            {...props}
            className='flex items-center gap-1 bg-neutral-100 border py-2 px-4 border-neutral-300 rounded-lg'
            inputRef={ref}>
            {children}
          </TimepickerInput>
        )}
        {...props}
      />
    </div>
  )
}

Timepicker.input = TimepickerInput

export default Timepicker
